<template>
    <b-row class="rowbg">
        <b-col md="12">
            <b-card>
                <b-card-title>Pakjesavond gaat van start</b-card-title>
                <b-card-text>
                    <b-img align="right" class="w-50 cardimage"  v-bind:src="$imagestore2+'images/artikelen/S&P-04-small.jpg'" fluid></b-img>
                    <p>Maak uw Pakjesavond onvergetelijk met een sfeervol en verrassend bezoek van <strong>Piet &amp; Piet bij jullie thuis</strong>! Wij zorgen voor een geweldige start van het feest, waarbij de huiskamer snel wordt gevuld met lachen en plezier. Dankzij onze zorgvuldige voorbereiding bieden we uw familie in <strong>20 minuten</strong> een fantastische ervaring, waarna u in alle rust het feest verder kunt vieren met een geweldige herinnering die nog lang onderwerp van gesprek zal zijn. Het leukste huisbezoek wat je je kan voorstellen
                    </p>
                    <p><strong>Piet &amp; Piet Bezoeken in Utrecht en Omgeving</strong><br>
                    <strong>Piet &amp; Piet</strong> komen bij u langs <strong>in en rondom Utrecht</strong> voor slechts <strong>€45,00</strong>. Ze nemen hun uitgebreide repertoire en het Online Grote Boek mee om de avond helemaal compleet te maken. Wilt u het bezoek nog specialer maken? Kies dan voor het bezoek van <strong>Sinterklaas en Pie</strong>t voor slechts <strong>€70,00</strong>. Een magische ervaring die uw Pakjesavond extra bijzonder maakt!
                    </p>
                </b-card-text>   
                </b-card>
            <b-card>
                <b-card-title>Het Online Grote Boek<span class="d-none d-md-inline"> – handig en overzichtelijk</span></b-card-title>
                <b-card-text>
                    <b-img align="left" class="w-50 cardimage"  v-bind:src="$imagestore2+'images/artikelen/S&P-16-small.jpg'" fluid></b-img>
                    <p>Voor uw <b>Huisbezoek</b> maken wij een unieke webpagina: het <b>Online Grote Boek</b>. Hierin kunt u makkelijk aangeven hoe oud uw kinderen zijn, hoe hun juf of meester heet, en wat de namen zijn van hun beste vriendjes!
                    </p>
                    <p>Het <b>Grote Boek</b> gaat verder dan alleen de kinderen. Hoe komen we binnen? Waar staan de cadeaus? Wie is de bridgepartner van oma? Dankzij het <b>Online Grote Boek </b>krijgen ook dit soort praktische vragen een duidelijk antwoord. Na de reservering ontvangt u toegang tot een invulformulier op onze website. Daar kunt u allerlei nuttige informatie over het <b>gezin of de familie</b> kwijt. Vanuit onze jarenlange ervaring geven wij bovendien handige tips om het bezoek vlekkeloos te laten verlopen.
                    </p>
                    <p>U kunt de informatie tot twee weken voor het <b>Huisbezoek</b> invullen en aanpassen. Zo weten <b>Piet & Piet</b> alles ruim van tevoren en kunnen zij zich goed voorbereiden.
                    </p>
                </b-card-text>
            </b-card>
            <b-card>
                <b-card-title> Repertoire van Piet</b-card-title>
                <b-card-text>
<p>
    Sinds dag één ontwikkelen wij ons eigen repertoire met vrolijke en herkenbare <strong>Sinterklaasliedjes</strong> voor kinderen. Van rustige verhaaltjes en theatrale momenten tot energieke spellen over paarden, pepernoten en stoomboten – onze <strong>Pietenmuziek</strong> is altijd afgestemd op de beleving van het kind.
</p>
<p>
    We maken ook <strong>originele liedjes</strong> over thema’s die dichtbij staan: tandenpoetsen, buitenspelen of knutselen. Vaak met een vrolijke videoclip erbij, zodat de voorpret thuis al kan beginnen!
</p>
<p>
    Onze muziek is gemaakt om samen te beleven: meezingen, uitbeelden, dansen – de kinderen doen écht mee. Zo is Piet er voor de hele groep, terwijl <strong>Sinterklaas</strong> aandacht geeft aan het individuele kind.
</p>
<p>
    Enkele van onze eigen liedjes zijn:
</p>
                    <silent-box class="galleryitems" :gallery="repertoire"></silent-box>
                </b-card-text>
            </b-card>
            <b-card>
                <b-card-title>Reserveer direct</b-card-title>
                <b-card-text>
                   <b-link to="/contact">
                        <b-img align="right" class="w-50 cardimage"  v-bind:src="$imagestore1+'/website%202018/Ridder-en-de-Prins---Piet-schrijft-in-het-Grote-boek.jpg'" fluid alt="Fluid image"></b-img>
                    </b-link>
                    <p>
                    Vul het contactformulier in met uw wensen en wij nemen zo snel mogelijk contact op.
                    </p>
                    <b-link href="https://groteboek.ridderendeprins.nl/contact">
                        <b-img align="left" fluid alt="Fluid image" v-bind:src="$imagestore1+'/logo/boeknu.png'" ></b-img>
                    </b-link> 
                    
                </b-card-text>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        name: 'Huisbezoek',
        data: function() {
            return {
                repertoire: [{
                        src: 'https://www.youtube.com/watch?v=nvkMp7pF-4U'
                    },
                    {
                        src: 'https://www.youtube.com/watch?v=7IdAfQsrcdw'
                    },
                    {
                        src: 'https://www.youtube.com/watch?v=hIuchunSDSs'
                    }
                ]
            }
        }
    }
</script>

<style>

</style>